"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("../../styles/components/TradeComponent.css");
require("./InstrumentPositionsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var instrumentPositionsClasses = (0, _cssClassesHelper.getBEMClasses)('instrument-positions-summary');
var InstrumentPositionsComponent = function InstrumentPositionsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(tradeComponentClasses(), instrumentPositionsClasses())
  }, props.showTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('header')
  }, t("Balances")), props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row-label')
  }, t("Product")), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-symbol')
  }, props.positions.position1.ProductSymbol), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-symbol')
  }, props.positions.position2.ProductSymbol)), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row-label')
  }, t("Available Balance")), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-available')
  }, props.positions.position1.AvailableBalance), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-available')
  }, props.positions.position2.AvailableBalance)), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row-label')
  }, t("Hold")), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-hold')
  }, props.positions.position1.Hold), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-hold')
  }, props.positions.position2.Hold)), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row-label')
  }, t("Pending Deposits")), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-pending-deposits')
  }, props.positions.position1.PendingDeposits), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-pending-deposits')
  }, props.positions.position2.PendingDeposits)), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('row-label')
  }, t("Total Balance")), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-total-balance')
  }, props.positions.position1.Amount), /*#__PURE__*/_react["default"].createElement("div", {
    className: instrumentPositionsClasses('product-total-balance')
  }, props.positions.position2.Amount))));
};
InstrumentPositionsComponent.defaultProps = {
  showTitle: true
};
InstrumentPositionsComponent.propTypes = {
  positions: _propTypes["default"].object.isRequired,
  showTitle: _propTypes["default"].bool
};
var _default = exports["default"] = InstrumentPositionsComponent;